import api from '@/api';

import { PageResult } from '@/core/request/PageResult';
import { PageRequest } from '@/core/request/PageRequest';

import { API_BASE_URL } from '..';
import {
  AlterStatusInventory,
  CreateInventoryRequest,
  Inventory,
  InventoryItemAllResponse,
  InventoryItemListResponse,
  InventoryItemsResponse,
  LaunchItemsRequest,
  ListItemInventoryParams,
  ListItemInventoryResponse,
  UpdateInventoryRequest,
  ValidateInventoryResponse,
} from './Inventory.types';

const CONTROLLER_URL = `${API_BASE_URL}/inventories`;

export async function listInventories(
  params?: PageRequest,
): Promise<PageResult<Inventory>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<Inventory>;
}

export async function createInventory(
  obj: CreateInventoryRequest,
): Promise<Inventory> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Inventory;
}

export async function getInventory(id: number): Promise<Inventory> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as Inventory;
}

export async function updateInventory(
  obj: UpdateInventoryRequest,
): Promise<Inventory> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Inventory;
}

export async function removeInventory(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function listItemsInventory(
  id: number,
  params?: ListItemInventoryParams,
) {
  const result = (await api.get(`inventory/v1/inventory/${id}/items`, {
    ...params,
  })) as unknown;

  return result as InventoryItemListResponse;
}

export async function listAllItemsInventory(id: number, params?: PageRequest) {
  const result = (await api.get(`inventory/v1/inventory/${id}/items`, {
    rows: 999999,
    // allItems: true,
    ...params,
  })) as unknown;

  return result as PageResult<ListItemInventoryResponse>;
}

export async function createItemInventory(
  obj: LaunchItemsRequest,
  inventoryId: number,
): Promise<InventoryItemsResponse> {
  const result = (await api.post(
    `inventory/v1/inventory/${inventoryId}/items`,
    obj,
    null,
  )) as unknown;

  return result as InventoryItemsResponse;
}

export async function updateItemInventory(
  obj: LaunchItemsRequest,
  inventoryId: number,
): Promise<InventoryItemsResponse> {
  const result = (await api.put(
    `inventory/v1/inventory/${inventoryId}/items`,
    obj,
    null,
  )) as unknown;

  return result as InventoryItemsResponse;
}

export async function updateAllInventory(
  obj: LaunchItemsRequest[],
  inventoryId?: number,
) {
  const result = (await api.put(
    `inventory/v1/inventory/${inventoryId}/items/all`,
    obj,
    null,
  )) as unknown;

  return result as Promise<InventoryItemAllResponse[]>;
}

export async function ResetUnmarkedItemsInventory(inventoryId?: number) {
  return (await api.post(
    `inventory/v1/inventory/${inventoryId}/items/mark-all-as-zero-quantity`,
    {},
    null,
  )) as unknown;
}

export async function ValidateInventory(inventoryId?: number) {
  const result = (await api.get(
    `inventory/v1/inventory/${inventoryId}/items/validate`,
    null,
  )) as unknown;

  return result as ValidateInventoryResponse;
}

export async function alterStatusInventory(
  obj: AlterStatusInventory,
): Promise<Inventory> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.id}/status`,
    obj,
    null,
  )) as unknown;

  return result as Inventory;
}

export async function nextCountInventory(
  inventoryId: number,
): Promise<Inventory> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${inventoryId}/nextCount`,
    {},
    null,
  )) as unknown;

  return result as Inventory;
}
